(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cake-addons"] && !Shopify.designMode) return;
  try {
    (function () {
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function initSummary(root) {
      var checkboxes = root.querySelectorAll('.cake-addons__checkbox');
      var summaryEl = root.querySelector('.cake-addons__summary');
      var summaryItems = root.querySelector('.cake-addons__summary-items');
      if (!checkboxes.length || !summaryEl || !summaryItems) return;

      checkboxes.forEach(function (cb) {
        cb.addEventListener('change', function () {
          var names = [...checkboxes]
            .filter(function (c) { return c.checked; })
            .map(function (c) {
              return c.closest('.cake-addons__item')
                .querySelector('.cake-addons__item-name').textContent.trim();
            });
          summaryEl.style.display = names.length ? 'flex' : 'none';
          summaryItems.textContent = names.join(', ');
        });
      });
    }

    document.querySelectorAll('.cake-addons[data-section-id]').forEach(initSummary);

    if (!window.__cakeAddonsSingle) {
      window.__cakeAddonsSingle = true;
      var busy = false;

      // window + capture: theme ke kisi bhi submit handler se pehle chalta hai
      window.addEventListener('submit', async function (e) {
        var form = e.target;
        if (!form || !form.matches || !form.matches('form[action$="/cart/add"]')) return;

        var scope = form.closest('.shopify-section') || document;
        var selected = [...scope.querySelectorAll('.cake-addons__checkbox:checked')];
        if (!selected.length) return; // extras nahi to theme ka normal flow

        e.preventDefault();
        e.stopImmediatePropagation();
        if (busy) return;
        busy = true;

        try {
          var fd = new FormData(form);

          // cake ki properties (gift note, delivery inputs agar form ke andar hain)
          var props = {};
          fd.forEach(function (v, k) {
            var m = k.match(/^properties\[(.+)\]$/);
            if (m && v !== '') props[m[1]] = v;
          });

          var main = {
            id: parseInt(fd.get('id'), 10),
            quantity: parseInt(fd.get('quantity') || 1, 10)
          };
          if (Object.keys(props).length) main.properties = props;

          var items = [main].concat(
            selected.map(function (cb) { return { id: parseInt(cb.value, 10), quantity: 1 }; })
          );

          var sectionIds = [...document.querySelectorAll('cart-items-component')]
            .map(function (el) { return el.dataset.sectionId; })
            .filter(Boolean)
            .join(',');

          var res = await fetch(ROOT + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items, sections: sectionIds })
          });
          var data = await res.json();

          if (data.status) {
            var err = new Event('cart:error', { bubbles: true });
            err.detail = {
              sourceId: form.id || 'cake-addons',
              data: { message: data.message, description: data.description, errors: data.errors }
            };
            document.dispatchEvent(err);
            console.error('Cake Add-Ons add.js failed:', data);
            return;
          }

          var cart = await fetch(ROOT + 'cart.js').then(function (r) { return r.json(); });

          var ev = new Event('cart:update', { bubbles: true });
          ev.detail = {
            resource: cart,
            sourceId: form.id || 'cake-addons',
            data: {
              source: 'cake-addons',
              itemCount: items.reduce(function (s, i) { return s + i.quantity; }, 0),
              sections: data.sections
            }
          };
          document.dispatchEvent(ev);
        } catch (err) {
          console.error('Cake Add-Ons cart error:', err);
        } finally {
          busy = false;
        }
      }, true);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
